// src/components/GameStatus.js
import React from 'react';
import './GameStatus.css';

function GameStatus({ gameState }) {
  if (!gameState) return null;

  const { deck_count, goods_token_piles, bonus_token_piles } = gameState;

  // 货物类型映射（固定顺序）
  const goodsOrder = [
    { key: 'diamond', label: '💎 钻石', color: '#e91e63' },
    { key: 'gold', label: '🥇 黄金', color: '#ffc107' },
    { key: 'silver', label: '🥈 白银', color: '#9e9e9e' },
    { key: 'cloth', label: '👔 布料', color: '#9c27b0' },
    { key: 'spice', label: '🌶️ 香料', color: '#ff5722' },
    { key: 'leather', label: '🎒 皮革', color: '#795548' }
  ];

  // 奖励代币映射（固定顺序）
  const bonusOrder = [
    { key: 'bonus_3', label: '3张' },
    { key: 'bonus_4', label: '4张' },
    { key: 'bonus_5', label: '5张' }
  ];

  return (
    <div className="game-status">
      <h3 className="status-title">游戏状态</h3>

      {/* 牌堆剩余 */}
      <div className="status-section">
        <div className="status-item deck-count">
          <span className="status-icon">🎴</span>
          <span className="status-label">牌堆剩余:</span>
          <span className="status-value">{deck_count} 张</span>
        </div>
      </div>

      {/* 货物代币 */}
      <div className="status-section">
        <h4 className="section-subtitle">货物代币</h4>
        {goods_token_piles && goodsOrder.map(({ key, label, color }) => {
          const count = goods_token_piles[key];
          if (count === undefined) return null;
          return (
            <div key={key} className="status-item token-item">
              <span className="token-label" style={{ color }}>
                {label}
              </span>
              <span className="token-count">{count}</span>
            </div>
          );
        })}
      </div>

      {/* 奖励代币 */}
      <div className="status-section">
        <h4 className="section-subtitle">奖励代币</h4>
        {bonus_token_piles && bonusOrder.map(({ key, label }) => {
          const count = bonus_token_piles[key];
          if (count === undefined) return null;
          return (
            <div key={key} className="status-item token-item">
              <span className="token-label">🏆 {label}</span>
              <span className="token-count">{count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default GameStatus;
